import { render, staticRenderFns } from "./addNewItem.vue?vue&type=template&id=026b9ac4&scoped=true"
import script from "./addNewItem.vue?vue&type=script&lang=js"
export * from "./addNewItem.vue?vue&type=script&lang=js"
import style0 from "./addNewItem.vue?vue&type=style&index=0&id=026b9ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026b9ac4",
  null
  
)

export default component.exports